/* eslint-disable react-hooks/exhaustive-deps */
import { useLocation } from 'react-router-dom';
import Preview from './preview';

function Popout() {
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const id = urlParams.get('id') || null;
	const from = urlParams.get('from') || null;
	const isPreviewing = urlParams.has('preview', true);

	return (
		<>
			<Preview id={id} from={from} isPreviewing={isPreviewing} />
		</>
	);
}

export default Popout;
